import VueRouter, { RouteConfig } from 'vue-router'
import { UniversityClazzType } from 'kuaidong-model'

const List = () => import('../views/running/List.vue')
const Edit = () => import('../views/running/Edit.vue')
const Poster = () => import('../views/running/Poster.vue')

const Stats = () => import('../views/running/Stats.vue')
const SchoolArea = () => import('../views/running/SchoolArea.vue')
const StatsClazz = () => import('../views/running/StatsClazz.vue')
const StatsStu = () => import('../views/running/StatsStu.vue')

export const listRoute: RouteConfig = {
  path: 'running-list',
  name: 'university_running_list',
  component: List,
  meta: {
    title: '阳光跑',
  },
}

export const editRoute: RouteConfig = {
  path: 'running-edit',
  name: 'university_running_edit',
  component: Edit,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '布置阳光跑',
  },
}

export const posterRoute: RouteConfig = {
  path: 'running-poster',
  name: 'university_running_poster',
  component: Poster,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '阳光跑',
  },
}

export const statsRoute: RouteConfig = {
  path: 'running-stats',
  name: 'university_running_stats',
  component: Stats,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '阳光跑任务详情',
  },
}

export const statSchoolAreaRoute: RouteConfig = {
  path: 'running-stat-school-area',
  name: 'university_running_school_area',
  component: SchoolArea,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '阳光跑任务详情',
  },
}

export const statsClazzRoute: RouteConfig = {
  path: 'running-stats-clazz',
  name: 'university_running_stats_clazz',
  component: StatsClazz,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '阳光跑任务详情',
  },
}

export const statsStuRoute: RouteConfig = {
  path: 'running-stats-stu',
  name: 'university_running_stats_stu',
  component: StatsStu,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '阳光跑任务详情',
  },
}

export default [listRoute, editRoute, posterRoute, statsRoute, statsClazzRoute, statsStuRoute, statSchoolAreaRoute]

export function navigateToUniversityRunningList(router: VueRouter) {
  router.push({ name: listRoute.name })
}

export function navigateToUniversityRunningEdit(router: VueRouter) {
  router.push({ name: editRoute.name })
}

export function redirectToUniversityRunningEdit(router: VueRouter) {
  router.replace({ name: editRoute.name })
}

export function redirectToUniversityRunningPoster(router: VueRouter, id: string) {
  router.replace({ name: posterRoute.name, query: { id } })
}

export function navigateToUniversityRunningPoster(router: VueRouter, id: string) {
  router.push({ name: posterRoute.name, query: { id } })
}

export function navigateToUniversityRunningStats(router: VueRouter, id: string) {
  router.push({ name: statsRoute.name, query: { id } })
}

export function navigateToUniversityRunningSchoolArea(router: VueRouter, id: string) {
  router.push({ name: statSchoolAreaRoute.name, query: { id } })
}

export function navigateToUniversityRunningStatsClazz(
  router: VueRouter,
  id: string,
  clazzType: UniversityClazzType,
  clazzId: string,
  clazzName: string
) {
  router.push({ name: statsClazzRoute.name, query: { id, clazzType, clazzId, clazzName } })
}

export function navigateToUniversityRunningStatsStu(
  router: VueRouter,
  id: string,
  clazzType: UniversityClazzType,
  clazzId: string,
  clazzName: string
) {
  router.push({ name: statsStuRoute.name, query: { id, clazzType, clazzId, clazzName } })
}
